// Customizable Area Start
import React from "react";
import {
    Box,
    Typography,
    styled,
    Button,
    Snackbar,
    Breadcrumbs,
    Tabs,
    Tab,
    Grid,
    Select,
    MenuItem,
} from "@material-ui/core";
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Sidebar from "../../../components/src/Sidebar.web";
import TaskListController from "./TaskListController";
import { down, milestone } from "./assets";
import { HeaderCard, IQuestion, Question, ReponseHeaderContainer, TabLabelText } from "../../../components/src/Question.web";
import SideNavbar from "../../../components/src/SideNavbar.web";
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import { DoughnutChart } from "../../../components/src/DoughnutChart";
const QuestionText: { [key: string]: string } = {
    "en": "Question",
    "fr": "Question",
    "de": "Frage",
    "es": "Pregunta"
}
const responses: { [key: string]: string } = {
    en: "Responses",
    fr: "Réponses",
    es: "Respuestas",
    de: "Antworten",
}


// Customizable Area End

// Customizable Area Start
export default class TaskList extends TaskListController {
    // Customizable Area Start
    renderTaskLoading = () => {
        return <></>
    }

    renderContent = () => {
        if(this.state.isViewReport){
            return this.renderViewReportMode()
        } else {
            return this.renderTaskList()
        }
    }

    renderTaskList = () => {
        const viewReport: { [key: string]: string } = {
            en: "View Report",
            fr: "Afficher le rapport",
            es: "Ver informe",
            de: "Bericht anzeigen",
          };
          const taskList: { [key: string]: string } = {
            en: "Task List",
            fr: "Liste des tâches",
            es: "Lista de tareas",
            de: "Aufgabenliste",
          };
          const milestoneSelect: { [key: string]: string } = {
            en: "Please select milestone",
            fr: "Veuillez sélectionner un jalon",
            es: "Por favor seleccione hito",
            de: "Bitte Meilenstein auswählen",
          };
        return <>
            <Typography
                variant="h6"
                style={{
                    color: "#292929",
                    fontSize: 18,
                    fontWeight: 600,
                    paddingTop: 30,
                    paddingBottom : 16,
                    fontFamily: 'Inter'
                }}
            >
                {taskList[this.state.language || 'en']}
            </Typography>
            {
                this.state.taskList.length > 0 ? this.state.taskList.map(task => {
                    const isSelectedTask = task.id == this.state.taskSelected
                    return <div className="taskContainer" key={`task-${task.id}`}>
                        <div data-test-id={`taskHeaderContainer-${task.id}`} className="taskHeaderContainer" onClick={() => this.onTaskSelected(task.id,task.attributes.completed_task
)}>
                            <Typography variant="subtitle1" className="taskName">{task.attributes.task_name}</Typography>
                            {
                                isSelectedTask ? <>
                                    <Typography variant="subtitle2" className="taskPointText">{this.state.patientTaskCompleted}/{this.state.totalPatient}</Typography>
                                    <Typography
                                        data-test-id={`viewReport1`}
                                        onClick={this.handleClickViewReport}
                                        variant="subtitle2" 
                                        className="taskViewReportText">
                                            {viewReport[this.state.language || 'en']}
                                        </Typography>
                                </> : null
                            }
                            <img style={{rotate: isSelectedTask  ? '0deg' : '180deg'}} src={down} />
                        </div>
                        {
                            isSelectedTask ? <div className="taskDescriptionContainer">
                                <div className="taskSeparator"></div>
                                <div dangerouslySetInnerHTML={{__html: task.attributes.description}}/>
                            </div> : null
                        }
                        
                    </div>
                }): <Typography style={{color: '#0009'}}>{milestoneSelect[this.state.language]}</Typography>
            }
        </>
    }

    renderViewReportMode = () => {
        const Back: { [key: string]: string } = {
            en: "Back",
            fr: "Dos",
            es: "Atrás",
            de: "Zurück",
          };
          const dashboard: { [key: string]: string } = {
            en: "Dashboard",
            fr: "Tableau de bord",
            es: "Panel",
            de: "Armaturenbrett",
          };
          const taskList: { [key: string]: string } = {
            en: "Task List",
            fr: "Liste des tâches",
            es: "Lista de tareas",
            de: "Aufgabenliste",
          };
        return <div style={{marginTop: 30}}>
            <div style={{display: 'flex'}}>
                <Button
                    onClick={this.exitViewReportMode}
                    variant="outlined"
                    className="backButton"
                    startIcon={<KeyboardBackspaceIcon style={{color: 'black'}} />}
                    >
                    <Typography
                        variant="h6"
                        style={{
                            color: "#292929",
                            fontSize: 18,
                            fontWeight: 600,
                            fontFamily: 'Inter'
                        }}
                    >
                        {Back[this.state.language || 'en']}
                    </Typography>
                </Button>
                <Breadcrumbs 
                    style={{
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center', // Vertically center contents
                        paddingLeft: 16,
                        marginLeft: 16,
                        background: 'rgba(192, 192, 192, 0.2)',
                        borderRadius: 10,
                    }} 
                    separator={<ArrowRightIcon style={{color: '#A046FB'}}/>}  
                    aria-label="breadcrumb">
                        <Button>
                            <Typography className="breadCrumbItem">
                            {dashboard[this.state.language || 'en']}
                            </Typography>
                        </Button>
                        <Button>
                            <Typography className="breadCrumbItem">
                            {taskList[this.state.language || 'en']}
                            </Typography>
                        </Button>
                    
                </Breadcrumbs>
            </div>

            <div style={{marginTop: 30}}>
                {this.renderTabHeader()}
                {this.renderTabQuestion()}
                {this.renderTabResults()}
            </div>
        </div>
    }

    renderTabHeader = () => {
        const questions : { [key: string]: string } = {
            en: "Questions",
            fr: "Questions",
            es: "Preguntas",
            de: "Fragen",
          };
        const response : { [key: string]: string } = {
            en: "Response",
            fr: "Réponse",
            es: "Respuesta",
            de: "Antwort",
          };
        return(
        <Tabs
            data-test-id="container-tabb"
            value={this.state.reportCurrentTab}
            onChange={this.handleCurrentTabChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            TabIndicatorProps={{
                style: {
                    height: 2, // Change the height of the indicator
                    backgroundColor: '#A046FB', // Change the color of the indicator
                  },
            }}
            style={{
                borderBottom: '1px solid #F0F0F0',
                textTransform: 'none',
            }}
        >
            <Tab 
                label={
                    <TabLabelText selected={this.state.reportCurrentTab == 0}>
                        {questions[this.state.language || 'en']}
                    </TabLabelText>
                } 
                style={{ minWidth: 'unset', width: 'auto', marginBottom: 8, textTransform: 'none' }} />
            <Tab 
                label={
                    <TabLabelText selected={this.state.reportCurrentTab == 1}>
                        <span>{response[this.state.language || 'en']}</span>&nbsp;&nbsp;
                            {/* {this.state.taskList.map((task, index) => (
                                index === 0 && (
                                    <span className="tabResultText" key={`task-${task.id}`}>                                       
                                        ({this.state.taskcompleted}/{task.attributes.total_task})
                                    </span>
                                )
                            ))} */}
                    </TabLabelText>
                } 
                style={{ minWidth: 'unset', width: 'auto', marginBottom: 8, textTransform: 'none' }} />
        </Tabs>
        )
    }

    renderTabQuestion = () => {
        return(
            <div
                role="tabpanel"
                hidden={this.state.reportCurrentTab !== 0}
                id={`full-width-tabpanel-0`}
                aria-labelledby={`full-width-tab-${0}`}
            >
                {this.state.questionList.map(question => {
                    const individualQuestion = this.state.individualQuestions.find(
                        item => String(item.id) === String(question.id)
                    )
                    const submittedMinimum = individualQuestion?.attributes?.minimum_value
                    const matchedAnswers = (this.state.usersAnswer || []).flatMap((user: any) =>
                        (user.answers || []).filter(
                            (item: any) => Number(item.answer.question_type_id) === Number(question.id)
                        )
                    )
                    const answerWithSelection = matchedAnswers.map((item: any, answerIndex: number) => {
                        const rangeValue = item?.answer?.range_value
                        const hasRangeValue = rangeValue !== null && rangeValue !== undefined && rangeValue !== ""
                        if (answerIndex !== 0 || hasRangeValue || submittedMinimum == null || submittedMinimum === "") {
                            return item
                        }
                        return {
                            ...item,
                            answer: {
                                ...item.answer,
                                range_value: submittedMinimum,
                            }
                        }
                    })
                    return (
                        <Question
                            language={this.state.language || "en"}
                            key={`question:${question.id}`}
                            data={question}
                            answer={answerWithSelection}
                        />
                    )
                })}
            </div>
        )
    }

    renderTabResults = () => {
          const summary : { [key: string]: string } = {
            en: "Summary",
            fr: "Résumé",
            es: "Resumen",
            de: "Zusammenfassung",
          };
          const question : { [key: string]: string } = {
            en: "Question",
            fr: "Question",
            es: "Pregunta",
            de: "Fragen",
          };
          const individual : { [key: string]: string } = {
            en: "Individual",
            fr: "Individuel",
            es: "Individual",
            de: "Person",
          };
        if(this.state.questionsWithAnwser.length > 0){
            return(
                <>
                    {this.state.taskList.map((task, index) => (
                        index === 0 && (
                <div
                    role="tabpanel"
                    key={`task-${task.id}`}
                    hidden={this.state.reportCurrentTab !== 1}
                    id={`full-width-tabpanel-1`}
                    style={{paddingBottom: 120, marginTop: 16,
                        marginBottom: 16,}}
                    aria-labelledby={`full-width-tab-${1}`}
                >
                    <ReponseHeaderContainer>
                        <HeaderCard
                            data-test-id="header-summary"
                            selected={this.state.currentResultHeaderIndex === 0} 
                            onClick={() => this.handleResultHeaderClick(0)}>
                                {summary[this.state.language || 'en']}
                        </HeaderCard>
                        <HeaderCard 
                            data-test-id="header-question"
                            style={{marginLeft: 16, marginRight: 16}}
                            selected={this.state.currentResultHeaderIndex === 1} 
                            onClick={() => this.handleResultHeaderClick(1)}>
                                {question[this.state.language || 'en']}
                        </HeaderCard>
                        <HeaderCard
                            data-test-id="header-individual"
                            selected={this.state.currentResultHeaderIndex === 2} 
                            onClick={() => this.handleResultHeaderClick(2)}>
                                {individual[this.state.language || 'en']}
                        </HeaderCard>
                    </ReponseHeaderContainer>
                    {this.renderResultTabContent()}
                </div>
                    )
                ))}
                </>
            )
        }
        return null
    }

    renderResultTabContent = () => {
        if(this.state.currentResultHeaderIndex === 0){
            return this.renderResultSummary()
        }
        if(this.state.currentResultHeaderIndex === 1){
            return this.renderResultQuestions()
        }
        if(this.state.currentResultHeaderIndex === 2){
            return this.renderResultIndividual()
        }
    }

    renderResultIndividual = () => {
        const patientID : { [key: string]: string } = {
            en: "Patient ID",
            fr: "ID du patient",
            es: "ID del paciente",
            de: "Patienten-ID",
          };
          const totalPoint : { [key: string]: string } = {
            en: "Total Point Earned",
            fr: "Total des points gagnés",
            es: "Punto total ganado",
            de: "Gesamtpunktzahl erreicht",
          };
          const noResponseText : { [key: string]: string } = {
            en: "No response given",
            fr: "Aucune réponse donnée",
            es: "No se ha dado respuesta",
            de: "Keine Antwort gegeben",
          };

          const noResponseForQuestionText: { [key: string]: string } = {
            en: "No response given for question",
            fr: "Aucune réponse donnée pour la question",
            es: "No se ha dado respuesta para la pregunta",
            de: "Keine Antwort für die Frage gegeben",
          };
          
        return <Grid container>
            {this.state.individualQuestions.length > 0 
            &&
            <Grid container item xs={12} style={{background: 'rgba(192, 192, 192, 0.2)', borderRadius: 10,}}>
                <Grid item xs={12} style={{alignItems: 'center', display: 'flex', borderBottom: '1px solid rgba(192, 192, 192, 0.3)', padding: 16}}>
                    <Button data-test-id="button-previous-user" onClick={this.onPreviousUser}  disabled={this.state.currentUserIndex === 0}>
                        <KeyboardArrowLeftIcon/>
                    </Button>
                    <span><span style={{color: "#A046FB"}}>{this.state.currentUserIndex + 1}</span> of {this.state.questionsWithAnwser[this.state.currentQuestionIndex].answers.length}</span>                    
                    <Button data-test-id="button-next-user" onClick={this.onNextUser}   disabled={this.state.currentUserIndex === this.state.questionsWithAnwser[this.state.currentQuestionIndex].answers.length - 1} >
                        <KeyboardArrowRightIcon/>
                    </Button>
                    {this.state.questionsWithAnwser[this.state.currentQuestionIndex].answers[this.state.currentUserIndex]?.account.id_number && (
                    <>
                    <TitleTextBold style={{marginLeft: 8, marginRight: 4 }}>
                        {patientID[this.state.language || 'en']}:
                    </TitleTextBold>
                    <span style={{flex: 1}}>
                        {this.state.questionsWithAnwser[this.state.currentQuestionIndex].answers[this.state.currentUserIndex].account.id_number}
                    </span>       
                    <TitleTextBold>
                        {totalPoint[this.state.language || 'en']}: {this.state.questionsWithAnwser[this.state.currentQuestionIndex].answers[this.state.currentUserIndex].account.scored_points || '0'}
                    </TitleTextBold>
                    </>
                    )}
                </Grid>
                <Grid item xs={12} style={{padding: 24}}>
                    <Typography
                        style={{
                            color: "#1F3650",
                            fontSize: 32,
                            fontWeight: 700,
                        }}
                    >
                        {this.state.currentTaskName}
                    </Typography>
                </Grid>
            </Grid>
            }

            <Grid item xs={12} style={{marginTop: 32, marginBottom: 16, borderBottom: '1px solid rgba(192, 192, 192, 0.3)'}}>
                    <TitleTextBold>{this.state.questionsWithAnwser[this.state.currentQuestionIndex].answers[this.state.currentUserIndex].account?.id_number}'s Response</TitleTextBold>
            </Grid>

            {/* {this.state.questionList.map(question => { */}
            {this.state.individualQuestions.length > 0 ? (
                this.state.individualQuestions.map((question, index) => {
                    const answer = this.state.usersAnswer[this.state.currentUserIndex]?.answers.filter(
                        answer => Number(answer.answer.question_type_id) === Number(question.id)
                    );

                    const sourceQuestion = this.state.questionList.find(
                        item => String(item.id) === String(question.id)
                    )
                    const submittedMinimum = question.attributes.minimum_value
                    const questionData = sourceQuestion?.attributes ? {
                        ...question,
                        attributes: {
                            ...question.attributes,
                            minimum_value: sourceQuestion.attributes.minimum_value,
                            maximum_value: sourceQuestion.attributes.maximum_value,
                            subtype: sourceQuestion.attributes.subtype || question.attributes.subtype,
                        }
                    } : question
                    const answerWithSelection = (answer || []).map((item: any, answerIndex: number) => {
                        const rangeValue = item?.answer?.range_value
                        const hasRangeValue = rangeValue !== null && rangeValue !== undefined && rangeValue !== ""
                        if (answerIndex !== 0 || hasRangeValue || submittedMinimum == null || submittedMinimum === "") {
                            return item
                        }
                        return {
                            ...item,
                            answer: {
                                ...item.answer,
                                range_value: submittedMinimum,
                            }
                        }
                    })

                    return answer?.length > 0 ? (
                        <Question
                            language={this.state.language || "en"}
                            key={`question:${question.id}`}
                            answer={answerWithSelection}
                            data={questionData}
                        />
                    ) : (
                            <Box style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                                <Typography key={`no-answer:${question.id}`}>
                                    {noResponseForQuestionText[this.state.language || "en"]} "{question.attributes.question}"
                                </Typography>
                                <br />
                            </Box>
                    );
                })
            ) : (
                <Typography>
                    {noResponseText[this.state.language || "en"]}
                </Typography>
            )}

        </Grid>
    }

    renderResultQuestions = () => {
        const arrowQestions : { [key: string]: string } = {
            en: "Press Left to Right arrow to change the questions",
            fr: "Appuyez sur la flèche gauche à droite pour changer les questions",
            es: "Presione la flecha de izquierda a derecha para cambiar las preguntas.",
            de: "Drücken Sie den Pfeil von links nach rechts, um die Fragen zu ändern",
          };
          const select : { [key: string]: string } = {
            en: "Select",
            fr: "Sélectionner",
            es: "Seleccionar",
            de: "Wählen",
          };
        let content = <></>
        const currentQuestion = this.state.questionsWithAnwser[this.state.currentQuestionIndex]
        if(["Subjective", "Dropdown-Based"].includes(currentQuestion?.attributes.question_type)){
            content = this.renderSubjectiveQuestion(currentQuestion)
        }
        if(currentQuestion.attributes.question_type === "Media-Based"){
            content = this.renderMediaBasedQuestion(currentQuestion)
        }
        if(currentQuestion.attributes.question_type === "MCQ" && currentQuestion.attributes.select_answer_type === "single"){
            content = this.renderSingleChoiceQuestion(currentQuestion)
        }
        if(currentQuestion.attributes.question_type === "MCQ" && currentQuestion.attributes.select_answer_type === "multiple"){
            content = this.renderMultipleChoiceQuestion(currentQuestion)
        }
        if(["Range-Based"].includes(currentQuestion.attributes.question_type)){
            content = this.renderRangeBasedQuestion(currentQuestion)
        }
        return <Grid container>
            <Grid container item xs={12} style={{background: 'rgba(192, 192, 192, 0.2)', borderRadius: 10,}}>
                <Grid item xs={12} style={{alignItems: 'center', display: 'flex', borderBottom: '1px solid rgba(192, 192, 192, 0.3)', padding: 16}}>
                    <Button data-test-id="button-previous-question"  onClick={this.onPreviousQuestion}>
                        <KeyboardArrowLeftIcon/>
                    </Button>
                    <span><span style={{color: "#A046FB"}}>{this.state.currentQuestionIndex + 1}</span> of {this.state.questionsWithAnwser.length}</span>
                    <Button data-test-id="button-next-question" onClick={this.onNextQuestion}>
                        <KeyboardArrowRightIcon/>
                    </Button>
                    <span style={{marginLeft: 16}}>
                        {arrowQestions[this.state.language || 'en']}
                    </span>
                </Grid>
                <Grid item xs={12} style={{padding: 24}}>
                    <StyledSelect
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"       
                        value={this.state.questionsWithAnwser[this.state.currentQuestionIndex].attributes.question}
                        onChange={this.handleChangeQuestionDropdown}
                        disableUnderline
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                            getContentAnchorEl: null,
                            }}
                        >
                        <MenuItem value="" disabled>{select[this.state.language || 'en']}</MenuItem>
                        {
                            this.state.questionsWithAnwser.map(question => question.attributes.question).map(question => {
                                return (
                                    <MenuItemWithoutHover key={`dropdown-option-${question}`} value={question}>{question}</MenuItemWithoutHover>
                                )
                            })
                        }
                    </StyledSelect>
                </Grid>
            </Grid>

            <Grid item xs={12} style={{borderBottom: '1px solid rgba(192, 192, 192, 0.3)', paddingTop: 32, paddingBottom: 16, marginBottom: 16,}}>
                <QuestionTitle>{`Question ${this.state.currentQuestionIndex + 1}: ${this.state.questionsWithAnwser[this.state.currentQuestionIndex].attributes.question}`}</QuestionTitle>
            </Grid>
            {
                content
            }
        </Grid>
    }

    renderResultSummary = () => {
        return(
            <Grid container>
                {
                    this.state.questionsWithAnwser.map((question, index) => {
                        const questionType = question.attributes.question_type
                        if(questionType === "MCQ" && question.attributes.select_answer_type === "single" || questionType === "Dropdown-Based"){
                            return this.renderSummarySingleChoiceQuestion(question, index)
                        }
                        if(questionType === "MCQ" && question.attributes.select_answer_type === "multiple" || questionType === "Range-Based"){
                            return this.renderSummaryMultipleChoiceQuestion(question, index)
                        }
                        if(questionType === "Subjective"){
                            return this.renderSummarySubjectiveQuestion(question, index)
                        }
                        if(questionType === "Media-Based"){
                            return this.renderSummaryMediaQuestion(question, index)
                        }
                    })
                }
            </Grid>
        )
    }

    renderSummarySingleChoiceQuestion = (question: IQuestion, index: number) => {
        return(
            <Grid item xs={12} style={{borderRadius: 10, background: 'rgba(192, 192, 192, 0.2)', marginTop: 32}}>
                <Grid item xs={12} style={{display: 'flex', padding: 32, borderBottom: '1px solid lightgray',}}>
                    <span style={{flex: 1}}>{QuestionText[this.state.language]} {index + 1}: {question.attributes.question}</span>
                     <span>{question.answers.length} {responses[this.state.language]}</span>
                </Grid>
                <DoughnutChart data={this.calculateDataset(question)}/>
            </Grid>
        )
    }

    renderSummarySubjectiveQuestion = (question: IQuestion, index: number) => {
        return(
            <Grid item xs={12} style={{borderRadius: 10, background: 'rgba(192, 192, 192, 0.2)', marginTop: 32}}>
                <Grid item xs={12} style={{display: 'flex', padding: 32, borderBottom: '1px solid lightgray',}}>
                    <span style={{flex: 1}}>{QuestionText[this.state.language]} {index + 1}: {question.attributes.question}</span>
                    <span>{question.answers.length} {responses[this.state.language]}</span>
                </Grid>
                {question.answers.map(item => {
                    return <p style={{margin: 32, padding: 16, borderRadius: 5, background: 'white',}}>
                        <span>{item.answer.answer_text}</span>
                    </p>
                })}
            </Grid>
        )
    }

    renderSummaryMediaQuestion = (question: IQuestion, index: number) => {
        return(
            <Grid item xs={12} style={{borderRadius: 10, background: 'rgba(192, 192, 192, 0.2)', marginTop: 32}}>
                <Grid item xs={12} style={{display: 'flex', padding: 32, paddingBottom: 0}}>
                    <span style={{flex: 1}}>{QuestionText[this.state.language]} {index + 1}: {question.attributes.question}</span>
                    <span>{question.answers.length} {responses[this.state.language]}</span>
                </Grid>
                {question?.attributes?.image?.url ?
                <Grid item xs={12} style={{padding: 32, borderBottom: '1px solid lightgray',}}>
                    <img 
                        style={{width: 100, height: 100}} 
                        src={question?.attributes?.image?.url}
                    />
                </Grid>
                 : null }
                <div style={{margin: 16,  maxWidth: '80vw', overflowX: 'auto', whiteSpace: 'nowrap'}}>
                    {[...question.answers].map(item => {
                        return <img src={item.answer.media_urls[0]} style={{ width: "100px", height: "100px", margin: 16, display: 'inline-block' }}/>
                    })}
                </div>

            </Grid>
        )
    }

    renderSummaryMultipleChoiceQuestion = (question: IQuestion, index: number) => {
        let data: any = {};
    
        if (question.attributes.question_type === "MCQ") {
            data = this.processAnswerListSubjective(question.answers);
            question.attributes.options.forEach(option => {
                if (!data[option.option_name]) {
                    data[option.option_name] = 0;
                }
            });
        } else {
            data = this.processAnswerListRangeBased(question.answers);
        }
    
        const formatedMultipleChoiceResult = Object.keys(data).map((key) => ({
            option: key,
            answerNumber: data[key]
        }));
    
        // Safely calculate mostAnswer
        let mostAnswer = formatedMultipleChoiceResult.length > 0
            ? Math.max(...formatedMultipleChoiceResult.map(item => item.answerNumber))
            : 0;
    
        return (
            <Grid item xs={12} style={{ borderRadius: 10, background: 'rgba(192, 192, 192, 0.2)', marginTop: 32 }}>
                <Grid item xs={12} style={{ display: 'flex', padding: 32, borderBottom: '1px solid lightgray' }}>
                    <span style={{ flex: 1 }}>
                        {QuestionText[this.state.language]} {index + 1}: {question.attributes.question}
                    </span>
                    <span>{(question.answers.length)} {responses[this.state.language]}</span>
                </Grid>
                <Grid item xs={12} style={{ padding: 32 }}>
                    {
                        formatedMultipleChoiceResult.map((answerFormated, idx) => {
                            const calculatedWidth = mostAnswer > 0
                                ? (answerFormated.answerNumber / mostAnswer) * 100
                                : 0;
                            const hasNoAnswer = answerFormated.answerNumber === 0;
    
                            return (
                                <Grid
                                    item
                                    container
                                    xs={12}
                                    key={answerFormated.option + "_" + idx}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'start',
                                        gap: '20px',
                                        // flexWrap: 'wrap'
                                    }}
                                >
                                    <Grid item xs={2} sm={1} style={{ minWidth: 30 }}>
                                        <span>{answerFormated.option}</span>
                                    </Grid>
                                    <div style={{ width: 1, height: 40, background: 'lightgray', marginLeft: '15px' }} />
                                    <Grid item xs={10} sm={7} style={{ height: 30 }}>
                                        <div
                                            style={{
                                                background: hasNoAnswer ? 'gray' : 'rgba(160, 70, 251, 1)',
                                                width: hasNoAnswer ? "2px" : `${calculatedWidth}%`,
                                                height: '100%'
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm="auto" style={{ marginLeft: 16 }}>
                                        <span>{answerFormated.answerNumber}</span>
                                    </Grid>
                                </Grid>
                            );
                        })
                    }
                </Grid>
            </Grid>
        );
    }    

    calculateDataset = (question: any) => {
        console.log(question)
        const labels = question.attributes.options.map((option: any) => {
          return option.option_name
        })
        const data: number[] = []
        labels.map((label: any) => {
          let count = 0;
          question.answers.forEach((answer: any) => {
            if(answer.answer.answer_text === label){
              count++
            }
          });
          data.push(count)
        })
        const backgroundColors = [
          'rgba(10, 6, 9, 0.94)',
          'rgba(70, 251, 242, 0.6)',
          'rgba(229, 215, 245, 0.8)',
          'rgba(70, 97, 251, 0.4)',
          'rgba(1, 0, 7, 0.02)',
          'rgba(240, 208, 68, 0.88)',
          'rgba(192, 82, 55, 0.2)',
          'rgba(105, 100, 49, 0.2)',
          'rgba(230, 13, 230, 0.2)',          
        ]
        const dataSet = {
          labels: labels,
          datasets: [{
            data: data,
            backgroundColor: backgroundColors,
            borderWidth: 1
          }]
        };
        return dataSet
      }

    renderSubjectiveQuestion = (currentQuestion: IQuestion) => {
        const formatedResult = this.processAnswerListSubjective(currentQuestion.answers)
        return(
            <>
                {Object.keys(formatedResult).map(answer => {
                    return(
                        <Grid key={answer} item xs={12} style={{background: 'rgba(192, 192, 192, 0.2)', borderRadius: 10, marginTop: 16,}}>
                            <div style={{borderBottom: '1px solid rgba(192, 192, 192, 0.3)', margin: 16, paddingBottom: 16}}>
                                <AnswerText>{answer}</AnswerText>
                            </div>
                            <div style={{margin: 16,}}>
                                <AnswerNumber>{formatedResult[answer]} {responses[this.state.language]}</AnswerNumber>
                            </div>
                        </Grid>
                    )
                })}
            </>
        )
    }

    renderRangeBasedQuestion = (currentQuestion: IQuestion) => {
        const formated = this.processAnswerListRangeBased(currentQuestion.answers)
        return(
            <>
                {Object.keys(formated).map(answerFormated => {
                    return(
                        <Grid key={answerFormated} item xs={12} style={{background: 'rgba(192, 192, 192, 0.2)', borderRadius: 10, marginTop: 16,}}>
                            <div style={{borderBottom: '1px solid rgba(192, 192, 192, 0.3)', margin: 16, paddingBottom: 16}}>
                                <AnswerText>{answerFormated}</AnswerText>
                            </div>
                            <div style={{margin: 16,}}>
                                <AnswerNumber>{formated[answerFormated]} {responses[this.state.language]}</AnswerNumber>
                            </div>
                        </Grid>
                    )
                })}
            </>
        )
    }

    renderMediaBasedQuestion = (currentQuestion: IQuestion) => {
        return(
            <>
                {currentQuestion.answers.map(answer => {
                    return(
                        <Grid key={answer.answer.media_urls[0]} item xs={12} style={{background: 'rgba(192, 192, 192, 0.2)', borderRadius: 10, marginTop: 16,}}>
                            <img src={answer.answer.media_urls[0]} style={{ width: "100px", height: "100px", margin: 16 }}/>
                        </Grid>
                    )
                })}
            </>
        )
    }

    renderSingleChoiceQuestion = (currentQuestion: IQuestion) => {
        const formatedResult = this.processAnswerListSubjective(currentQuestion.answers)
        return(
            <>
            {Object.keys(formatedResult).map(answer => {
                return(
                    <Grid key={answer} item xs={12} style={{background: 'rgba(192, 192, 192, 0.2)', borderRadius: 10, marginTop: 16,}}>
                        <div style={{borderBottom: '1px solid rgba(192, 192, 192, 0.3)', display: 'flex', alignItems: 'center', margin: 16, paddingBottom: 16}}>
                            <RadioButtonCheckedIcon  style={{ color: "#A046FB", marginRight: 16 }}/>
                            <AnswerText>{answer}</AnswerText>
                        </div>
                        <div style={{margin: 16,}}>
                            <AnswerNumber>{formatedResult[answer]} {responses[this.state.language]}</AnswerNumber>
                        </div>
                    </Grid>
                )
            })}
        </>
        )
    }

    renderMultipleChoiceQuestion = (currentQuestion: IQuestion) => {
        const formatedResult = this.processAnswerListMultipleChoice(currentQuestion.answers)
        return(
            <>
            {Object.keys(formatedResult).map(combineAnswer => {
                return(
                    <Grid key={combineAnswer} item xs={12} style={{background: 'rgba(192, 192, 192, 0.2)', borderRadius: 10, marginTop: 16,}}>
                        {combineAnswer.split("---").map(answer => {
                            return(
                                <div key={`answer-${answer}`} style={{borderBottom: '1px solid rgba(192, 192, 192, 0.3)', display: 'flex', alignItems: 'center', margin: 16, paddingBottom: 16}}>
                                    <CheckBoxOutlinedIcon style={{ color: "#A046FB", marginRight: 16 }}/>
                                    <AnswerText>{answer}</AnswerText>
                                </div>
                            )
                            })
                        }
                        <div style={{margin: 16,}}>
                            <AnswerNumber>{formatedResult[combineAnswer]} {responses[this.state.language]}</AnswerNumber>
                        </div>
                    </Grid>
                )
            })}
        </>
        )
    }

    renderSnackbar = () => {
        return(
            <Snackbar
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
                }}
                open={this.state.openSnackbar}
                autoHideDuration={6000}
                message={this.state.snackbarContent}
                onClose={this.handleCloseSnackbar}
            />
        )
    }
    // Customizable Area End

    // Customizable Area Start
    render() {
        const taskList: { [key: string]: string } = {
            en: "Task List",
            fr: "Liste des tâches",
            es: "Lista de tareas",
            de: "Aufgabenliste",
          };
          const selectMilstone: { [key: string]: string } = {
            en: "Select Milstone",
            fr: "Sélectionnez un jalon",
            es: "Seleccionar hito",
            de: "Wählen Sie Meilenstein aus",
          };
          const titleBar: { [key: string]: string } = {
            en: "Welcome to your Task List tab! Here, you can view the tasks assigned to patients and the questions and the corresponding responses.",
            fr: "Bienvenue dans l'onglet Liste des tâches ! Ici, vous pouvez visualiser les tâches assignées aux patients et les questions et réponses correspondantes.",
            es: "¡Bienvenido a la pestaña Lista de tareas! Aquí puede ver las tareas asignadas a los pacientes y las preguntas y respuestas correspondientes.",
            de: "Willkommen auf der Registerkarte „Aufgabenliste“! Hier können Sie die den Patienten zugewiesenen Aufgaben sowie die Fragen und die dazugehörigen Antworten einsehen",
          };

          const NoMilestone : { [key: string]: string } = {
            en: "No milestone found",
            fr: "Aucun jalon trouvé",
            es: "No se encontró ningún hito",
            de: "Kein Meilenstein gefunden",
          };
        return (
            // Customizable Area Start
            <>
                <SideNavbar
                    navigation={this.props.navigation}
                    id={this.props.id}
                    showStudy={true}
                    showButtonChats
                    showButtonNotification
                    handleLanguageSwitch={this.handleLanguageSwitch}
                    language={this.state.language}
                />
                
               
                <ContainerBox>
                    <Sidebar
                        navigation={this.props.navigation}
                        id={this.props.id}
                        selected="task_list"
                        language={this.state.language}
                    />
                <Grid container >
                <Grid item xs={10} sm={9}>
                    <Box style={{ flex: 1, padding:'30px'}}>
                        <Typography
                            style={{
                                color: "#1F3650",
                                marginBottom: 30,
                                fontFamily: "Jost",
                                fontSize: "40px",
                                fontWeight: 700,
                                lineHeight: "50px",
                                textAlign: "left",
                            }}
                        >
                            {taskList[this.state.language || 'en']}
                        </Typography>

                        <Typography
                            style={{
                                color: "#414141",
                                marginBottom: 50,
                                fontFamily: "Jost",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "26px",
                                textAlign: "left"
                            }}
                        >
                            {titleBar[this.state.language || 'en']}
                        </Typography>

                        <div style={{ position: 'relative', width: '100%' }}>
                            <div
                                data-test-id='GetMilestone'
                                style={{
                                    display: 'flex',
                                    padding: '10px',
                                    border: '1px solid #ccc',
                                    cursor: 'pointer',
                                    alignItems: 'center',
                                    borderRadius: '5px',
                                    justifyContent: 'space-between'
                                }}
                                onClick={() => this.setState(prev => {
                                    return {
                                        openMilestoneOptions: !prev.openMilestoneOptions
                                    }
                                })}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <img src={milestone} style={{ width: "20px", height: "20px", marginRight: "5px" }} />


                                    <span style={this.state.selectedMilestone ? {
                                        color: '#454545',
                                        fontFamily: 'Inter',
                                        fontSize: '14px',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        lineHeight: 'normal',
                                    } : {
                                        color: 'var(--Grey-Base, #939393)',
                                        fontFamily: 'Inter',
                                        fontSize: '14px',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        lineHeight: 'normal',
                                    }}>
                                        {this.state.selectedMilestone || `${selectMilstone[this.state.language || 'en']}`}
                                    </span>
                                </div>

                                <img src={down} />
                            </div>
                            {
                                this.state.openMilestoneOptions ? <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: '0',
                                    width: '100%',
                                    backgroundColor: '#fff',
                                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                    borderRadius: '5px', borderTop: 'none', zIndex: 100,
                                    marginBottom: '20px',
                                    maxHeight: '250px',
                                    overflow: 'auto'
                                }}>
                                    {
                                        this.state.milestoneOptions.length > 0 ? this.state.milestoneOptions.map(milestone => {
                                            return <div
                                                    data-test-id={`milestone-${milestone.id}`}
                                                    key={`milestone${milestone.id}`} 
                                                    className="milestoneContainer" 
                                                    onClick={() => this.onMilestoneSelected(milestone)}>
                                                <span>{milestone.name}</span>
                                            </div>
                                        })
                                    : <p>{NoMilestone[this.state.language || "en"]}</p>}
                                </div> : null
                            }
                        </div>

                        {
                            this.state.isLoadingTaskList ? this.renderTaskLoading() : this.renderContent()
                        }
                    </Box>
                    {this.renderSnackbar()}
                </Grid>
                <Grid item xs={2} sm={3} >
                </Grid>
                </Grid>
                </ContainerBox>

            </>
            // Customizable Area End
        );
    }
    // Customizable Area End
}
// Customizable Area End

// Customizable Area Start
const ContainerBox = styled(Box)({
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    "& .milestoneContainer": {
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        paddingRight: "16px",
    },
    "& .milestoneContainer:hover": {
        backgroundColor: '#F0F0F0',
        cursor: 'pointer', // Optional: Change cursor on hover
    },
    "& span": {
        fontFamily: "Inter",
    },
    "& p": {
        fontFamily: "Inter",
    },
    "& .taskContainer": {
        background: '#F0F0F0',
        marginBottom: 16,
        borderRadius: 10
    },
    "& .taskContainer:hover": {
        backgroundColor: '#F0F0F0',
        cursor: 'pointer', 
    },
    "& .taskPointText": {
        color: '#A046FB',
        marginLeft: 16,
        marginRight: 8,
        fontWeight: 600,
        fontFamily: 'Inter',
        fontSize: 15,
    },
    "& .taskViewReportText": {
        color: '#A046FB',
        textDecoration: 'underline',
        marginLeft: 8,
        marginRight: 24,
        fontWeight: 600,
        fontFamily: 'Inter',
        fontSize: 15,
    },
    "& .taskName": {
        flex: 1, 
        fontWeight: 600,
        fontFamily: 'Inter',
        fontSize: 16,
        color: '#292929'
    },
    "& .taskHeaderContainer": {
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
    },
    "& .taskSeparator": {
        flex: 1, 
        height: 1, 
        background: 'rgba(192, 192, 192, 0.3)', 
        marginBottom: 16
    },
    "& .taskDescriptionContainer": {
        paddingLeft: 16,
        paddingBottom: 8,
        paddingRight: 16
    },
    "& .backButton": {
        borderRadius: 5,
        border: "2px solid #A046FB",
        textTransform: 'none'
    },
    "& .breadCrumbItem": {
        fontSize: 16,
        fontWeight: 500,
        color: 'rgba(192, 192, 192, 0.9)',
        textTransform: 'none'
    },
    "& .tabResultText": {
        fontSize: 16,
        fontWeight: 600,
        color: '#A046FB',
        textTransform: 'none'
    }
});

const StyledSelect = styled(Select)({
    width: '100%',
    minHeight: 50,
    paddingLeft: 16,
    paddingRight: 16,
    background: 'white',
    borderRadius: 5,
    border: '1px solid rgba(192, 192, 192, 0,3)',
    '& .MuiSelect-select': {
        borderBottom: 'none', // Remove the underline
    },
    '& :focus': {
        background: 'white',
        backgroundColor: 'white'
    },
});

const MenuItemWithoutHover = styled(MenuItem)({
    '&:hover': {
        backgroundColor: 'transparent', // Disable hover effect,
        background: 'white'
    },
    '&:focus': {
        backgroundColor: 'transparent', // Disable hover effect,
        background: 'white'
    }
})

const QuestionTitle = styled(`span`)({
    fontWeight: 700,
    fontFamily: 'Inter',
    color: 'black',
    fontSize: 16,
})

const AnswerText = styled(`span`)({
    fontWeight: 700,
    fontFamily: 'Inter',
    color: 'black',
    fontSize: 15,
})

const AnswerNumber = styled(`span`)({
    fontWeight: 500,
    fontFamily: 'Inter',
    color: 'gray',
    fontSize: 15,
})

const TitleTextBold = styled(`span`)({
    fontFamily: "Inter", 
    fontWeight: 700, 
    color: 'black'
})
// Customizable Area End
